let language = {
    FOOTER_QPMN_TITLE:"STAY IN TOUCH WITH US",
    FOOTRT_FACEBOOK_HINT:"Follow on Facebook",
    FOOTRT_INSTAGRAM_HINT:"Follow on Instagram"
};

export { language }